import { render, staticRenderFns } from "./SingleOtpInput.vue?vue&type=template&id=4568c326&scoped=true&lang=html"
import script from "./SingleOtpInput.vue?vue&type=script&lang=js"
export * from "./SingleOtpInput.vue?vue&type=script&lang=js"
import style0 from "./SingleOtpInput.vue?vue&type=style&index=0&id=4568c326&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568c326",
  null
  
)

export default component.exports